import { useContext } from 'react';
import PreferencesContext from './PreferencesContext';

const usePreferencesContext = () => useContext(PreferencesContext);

export default usePreferencesContext;
